import { onGlobalSetup, onMounted, ssrRef, provide, useRoute } from '@nuxtjs/composition-api';
import { REGEX_MOBILE, REGEX_TABLET, REGEX_BOT, REGEX_IG, REGEX_IPHONE } from '~/constants/config';

export default function (ctx, inject) {
  onGlobalSetup(() => {
    const route = useRoute();
    const isMobile = ssrRef(true);
    const isTablet = ssrRef(false);
    const isDesktop = ssrRef(false);
    const isBot = ssrRef(false);
    const isInstagram = ssrRef(false);
    const isIPhone = ssrRef(false);

    const checkDeviceMode = () => {
      // handleWindowResize();
    };

    const userAgent = ctx.req ? ctx.req.headers['user-agent'] : navigator.userAgent;
    // const customIsTabet = ctx.$device.isTablet || (userAgent && userAgent.includes('iPad'));
    const devices = {
      isMobile,
      isTablet,
      isDesktop,
      isBot,
      isInstagram,
      isIPhone,
      checkDeviceMode,
    };
    if (process.server) {
      // isMobile.value = ctx.$device.isMobile;
      // isDesktop.value = !ctx.$device.isMobile;
      // isTablet.value = customIsTabet;
      isMobile.value = REGEX_MOBILE.test(userAgent);
      isDesktop.value = !REGEX_MOBILE.test(userAgent);
      isTablet.value = REGEX_TABLET.test(userAgent);
      isBot.value = REGEX_BOT.test(userAgent);
      isInstagram.value = REGEX_IG.test(userAgent);
    } else {
      isInstagram.value = REGEX_IG.test(userAgent);
      isIPhone.value = REGEX_IPHONE.test(userAgent);
    }
    provide('devices', devices);

    const handleWindowResize = () => {
      if (isMobile.value && route.value.path.startsWith('/oyun/')) return;

      if (process.server) return;
      // const viewportWidth = window.innerWidth;
      const viewportWidth = document.documentElement.clientWidth;
      if (viewportWidth < 640) {
        isMobile.value = true;
        isTablet.value = false;
      } else if (viewportWidth >= 640 && viewportWidth < 1024) {
        isMobile.value = false;
        isTablet.value = true;
      } else {
        isMobile.value = false;
        isTablet.value = false;
      }
    };

    onMounted(() => {
      // handleWindowResize(); // sadece dev modunda mi acsak?
      window.addEventListener('resize', handleWindowResize);
    });
  });
}
